var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h1',[_vm._v("About Page")]),_c('p',[_vm._v("First Name: "+_vm._s(this.$route.query.firstname))]),_c('p',[_vm._v("Email: "+_vm._s(this.$route.query.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }